<script>
import Home from '../view/Home.vue'
import answer from '../view/disc/answer.vue'
import login from '../view/disc/login.vue'
import result from '../view/disc/result.vue'

const routes = [
  { path: '/', component: login },
  { path: '/Home', component: Home },
  { path: '/answer', name:'answer', component: answer },
  { path: '/login', name:'login', component: login },
  { path: '/result', component: result },

]

export default routes;
</script>
